import {Base} from "@/api/Base"

export class OvertimeApplicationDelete extends Base {
    path = "overtimeApplication/delete"
}